module.exports = __webpack_public_path__ + "static/media/bottom_shape_7.9f12a0ba.svg";